<template>
  <div class="circleLetterGroup">
    <div class="circleLetter" v-on:click="userChangeOption(0)">
      <div class="textContainer textBase center">
          <p class="center">{{ letter }}</p>
      </div>
    </div>
    <div class="circleLetter">
      <div class="textContainer textBase center">
          <p class="center">B</p>
      </div>
    </div>
    <div class="circleLetter">
      <div class="textContainer textBase center">
          <p class="center">C</p>
      </div>
    </div>
  </div>
</template>
<style scoped>
.circleLetterGroup {
    display: block;
    position: absolute;
    height: 100px;
}
.circleLetterGroup .circleLetter{
  position: relative !important;
  margin-right: 20px;
  display: inline-block;
  transition: 0.1s;
}
.circleLetterGroup .circleLetter p {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}
.circleLetterGroup .circleLetter:active {
transform: scale(0.9);
background-color: black;
}
</style>
<script>
    export default {
        props: ['word'],
        data() {
            return {
                letter: 'A',
                slideIndex:0,
                lastFade:0,
                dbId:"undefined",
                letterPool:['A', 'B', 'C', 'D', 'E', 'F']
            }
        },
        computed: {
            currentOption(){
                return this.options[this.slideIndex]
            }         
        },
        methods: {
            saveInput(){
                this.$db.options.put({
                    id: this.dbId,
                    option: this.slideIndex
                }).catch(function(error){
                    console.log("error saving option: " + error);
                    return;
                });
                console.log("success saving option: " + this.slideIndex);
            },
            async loadInput(){
                var value = await this.$db.options.get({
                id: this.dbId,
                }).catch(function(error){
                    console.log("error loading option: " + error);
                });
                if (value === undefined) return;
                console.log(value);
                this.setOption(value.option);
            },
            loadOptions(options) {
                this.options = options;
                console.log("options loaded! " + this.options);
            },
            userChangeOption(n) {
              console.log(n);
              var letterIndex = 0;
              for (var i = 0; i < this.letterPool.length; i++) {
                if (this.letterPool[i]==this.letter) {
                  letterIndex = i;
                  break;
                }
              }

              this.letter = this.letterPool[letterIndex+1];
            },
            setOption(n) {
                this.slideIndex = n;

                var optionElement = this.$refs.optionID;

                if (this.lastFade == 0) {
                    optionElement.classList.remove("fadeA");
                    optionElement.classList.add("fadeB");
                    this.lastFade = 1;
                }
                else if (this.lastFade == 1) {
                    optionElement.classList.remove("fadeB");
                    optionElement.classList.add("fadeA");
                    this.lastFade = 0;
                }
            }
        },
        async created() {
            this.loadInput();
        },
        mounted(){
            this.dbId = `${this.$route.params.type}-${this.$route.params.chapter}-${this.$route.params.number}-NOT IMPLEMENTED------`;

            this.loadInput();
            this.setOption(this.slideIndex);
        }
    }
</script>
